<template>
  <div class="goal-config">
    <div class="search">
      <el-form label-width="70" inline>
        <el-form-item label="员工姓名" prop="employeeName">
          <el-input style="width: 200px" v-model="searchInfo.employeeName" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label="目标年份" prop="employeeName">
          <el-date-picker
            style="width: 200px"
            v-model="searchInfo.year"
            type="year"
            placeholder="请选择"
            value-format="yyyy"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click.stop="getTableData({ pageNum: 1 })"
          >查询</el-button>
          <el-button
            style="margin-left: 6px;"
            @click.stop="resetSearchInfoHandle()"
          >重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="btn-group">
      <el-button type="primary" @click.native="showOrHideSetGoalModalHandle">设置目标规则</el-button>
      <el-button type="primary" @click.native="showOrHideSetGroupMemberModalHandle">设置小组成员</el-button>
    </div>
    <!-- 表格 -->
    <div class="table">
      <customTable
        border
        :max-height="tableMaxHeight"
        :tableData="tableData"
        :column="tableColumns"
        :showPages="true"
        :currentPageSize="pageInfo.pageSize"
        :currentPage="pageInfo.pageNum"
        :total="pageInfo.total"
        @pageChange="changePageHandle"
      >
        <template slot="action" slot-scope="data">
          <el-link type="primary" style="margin-right: 20px;" @click="showOrHideGoalDetailModalHandle($event, data.row)">查看目标</el-link>
          <el-link type="danger" @click="deleteGoalHandle($event, data.row.userTargetConfigId)">删除</el-link>
        </template>
      </customTable>
    </div>

    <!-- 设置目标弹窗 -->
    <CustomModal
      v-model="showSetGoalModal"
      title="设置目标"
      width="800px"
      submitBtnText="生成目标"
      @submitHandle="submitHandle"
      @cancelHandle="showOrHideSetGoalModalHandle"
    >
      <SetGoalConfig ref="setGoalConfigRef" />
    </CustomModal>

    <!-- 目标详情弹窗 -->
    <CustomModal
      v-model="showGoalDetailModal"
      title="目标详情"
      width="800px"
      :showSubmitBtn="false"
      submitBtnText="生成目标"
      cancelBtnText="关闭"
      @cancelHandle="showOrHideGoalDetailModalHandle"
    >
      <GoalDetail ref="goalDetailRef" :goalId="currentEmployeeInfo.userTargetConfigId" :employeeName="currentEmployeeInfo.empName" />
    </CustomModal>

    <!-- 设置目标弹窗 -->
    <CustomModal
      v-model="showSetGroupMemberModal"
      title="设置小组成员"
      width="1000px"
      :showSubmitBtn="false"
      cancelBtnText="关闭"
      @cancelHandle="showOrHideSetGroupMemberModalHandle"
    >
      <SetGroupMember ref="setGroupMemberRef" />
    </CustomModal>
  </div>
</template>

<script>
import request from '@/utils/request'
import utils from '@/views/DoctorVisitLTC/utils/index.js'
const tableColumns = [
  { label: '序号', width: 60, type: 'index' },
  { label: '姓名', prop: 'empName' },
  { label: '目标年', prop: 'year'},
  { label: '五星医生', prop: 'fiveStarNum'},
  { label: '四星医生', prop: 'fourStarNum' },
  { label: '三星医生', prop: 'threeStarNum' },
  { label: '操作人', prop: 'operatorName' },
  { label: '操作时间', prop: 'createTime', width: 160 },
  { label: '操作', width: 150, slotName: 'action' }
]

export default{
  data() {
    return {
      tableMaxHeight: 0,
      pageInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 100
      },
      searchInfo: {
        employeeName: '',
        year: ''
      },
      tableColumns,
      tableData: [],
      showSetGoalModal: false,
      showGoalDetailModal: false,
      showSetGroupMemberModal: false,
      currentEmployeeInfo: {}
    }
  },
  methods: {
    async getTableData() {
      const params = {
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
        queryStr: this.searchInfo.employeeName,
        year: this.searchInfo.year
      }
      try {
        const res = await request.get('/cluepool/pc/admin/target/list', params, '')
        if (res.code === 200) {
          const data = res.data || {}
          this.tableData = (data.data || []).map(item => ({
            ...item,
            threeStarNum: item.saleStartTargetMap[3] || 0,
            fourStarNum: item.saleStartTargetMap[4] || 0,
            fiveStarNum: item.saleStartTargetMap[5] || 0
          }))
          this.pageInfo.total = data.total || 0
        } else {
          this.$message.error(res.message)
        }
      } catch (error) {
        console.log('获取目标配置列表失败', error)
      }
    },

    changePageHandle({ current, size }) {
      this.pageInfo.pageNum = current
      this.pageInfo.pageSize = size
      this.getTableData()
    },
    resetSearchInfoHandle() {
      this.searchInfo.employeeName = ''
      this.searchInfo.year = new Date().getFullYear().toString()
      this.getTableData()
    },

    submitHandle() {
      if (this.$refs.setGoalConfigRef) {
        this.$refs.setGoalConfigRef.$refs.formRef.validate((valid) => {
          if (valid) {
            this.checkEmployeeHandle()
          } else {
            console.log('提交失败')
          }
        })
      }
    },

    // 校验已选员工是否已经配置了目标
    async checkEmployeeHandle() {
      const formData = this.$refs.setGoalConfigRef.formData || {}
      const params = {
        year: formData.year,  // 目标年份
        empNumbers: formData.employeeList.map(item => item.value)  // 员工工号
      }
      try {
        const res = await request.get('/cluepool/pc/admin/target/getRepeatTargetUserInfos', params, '')
        if (res.code === 200) {
          if (res.data && res.data.length > 0) {
            const result = await utils.messageBoxConfirm({
              title: '提示',
              message: `检测到${res.data.map(item => item.nickName).join('、')}已配置了${formData.year}年目标规则，重新生成后，将覆盖原有${formData.year}年目标数据，是否继续？`,
              cancelButtonText: '取消',
              confirmButtonText: '继续'
            })
            if (result) {
              this.submitGoalHandle(true)
            }
          } else {
            this.submitGoalHandle(true)
          }
        } else {
          this.$message.error(res.message)
        }
      } catch (error) {
        console.log('校验已选员工是否已经配置了目标数据请求失败', error)
      }
    },

    // 提交目标
    async submitGoalHandle(force = false) {
      const formData = this.$refs.setGoalConfigRef.formData || {}
      const user = this.$session.get('user') || {}
      const params = {
        year: formData.year,  // 目标年份
        empNumbers: formData.employeeList.map(item => item.value),  // 员工工号
        force,
        goals: formData.goalTableData.map(item => ({
          avgStar: item.starNum,
          saleStar: item.starNum,
          period: item.period,
          targetNumber: item.goalNum
        })),
        operatorCode: user.userCode,
        operatorName: user.nickName
      }
      try {
        const res = await request.post('/cluepool/pc/admin/target/generate', params, '')
        if(res.code === 200) {
          this.$message.success('生成目标成功')
          this.showOrHideSetGoalModalHandle()
          this.getTableData()
        } else {
          this.$message.error(res.message)
        }
      } catch (error) {
        console.log('提交目标数据请求失败', error)
      }
    },

    // 显示或隐藏设置目标弹窗
    showOrHideSetGoalModalHandle() {
      this.showSetGoalModal = !this.showSetGoalModal
    },

    // 显示或隐藏目标详情
    showOrHideGoalDetailModalHandle(event, itemInfo) {
      this.currentEmployeeInfo = itemInfo || {}
      this.showGoalDetailModal = !this.showGoalDetailModal
      if (!this.showGoalDetailModal) {
        this.getTableData()
      }
    },

    // 显示或隐藏设置小组成员弹窗
    showOrHideSetGroupMemberModalHandle() {
      this.showSetGroupMemberModal = !this.showSetGroupMemberModal
    },

    // 删除目标
    async deleteGoalHandle(event, id) {
      const validConfirm = await utils.messageBoxConfirm({
        title: '提示',
        message: '确认删除目标？'
      })
      if (!validConfirm) return
      const params = {
        userTargetConfigId: id
      }
      try {
        const res = await request.delete('/cluepool/pc/admin/target/deleteTarget', params, '')
        if (res.code === 200) {
          this.$message.success('删除目标成功')
          if (this.tableData.length === 1 && this.pageInfo.pageNum > 1) {
            this.pageInfo.pageNum -= 1
          }
          this.getTableData()
        } else {
          this.$message.error(res.message)
        }
      } catch (error) {
        console.log('删除目标数据请求失败', error)
      }
    }
  },
  created() {
    this.tableMaxHeight = document.documentElement.clientHeight - 300;
    this.resetSearchInfoHandle()
  },
  components: {
    CustomTable: () => import ('@/components/customTable/customTable.vue'),
    CustomModal: () => import ('@/views/DoctorVisitLTC/components/customModal/Custom_Modal.vue'), 
    SetGoalConfig: () => import ('./components/SetGoalConfig.vue'),
    GoalDetail: () => import ('./components/GoalDetail.vue'),
    SetGroupMember: () => import ('./components/setGroupMember/SetGroupMember.vue')
  }
}
</script>

<style scoped lang="less">
.goal-config {
  padding: 16px;
  box-sizing: border-box;
  background-color: #fff;
  .btn-group {
    margin-bottom: 10px;
  }
}
</style>
